import { useTrans } from 'core/hooks';
import { useDispatch } from 'react-redux';
import filterActions from 'core/redux/features/filters/actions';
import {
  actions as navActions,
  NavTypes,
} from 'core/redux/features/shared/nav';

interface IResetButton {}

export const ResetButton = (_: IResetButton) => {
  const trans = useTrans();
  const dispatch = useDispatch();

  return (
    <button
      onClick={e => {
        e.preventDefault();
        dispatch(filterActions.resetAll());
        dispatch(navActions.close(NavTypes.Filter));
      }}
      className="button is-filter is-plain is-pulled-right"
    >
      <span className="button-slider-text">{trans('reset_filter')}</span>
    </button>
  );
};
